import { Injectable } from '@angular/core';

function _window(): Window & { [key: string]: any } {
  // return the global native browser window object
  return window;
}

@Injectable()
export class WindowRef {
  get nativeWindow(): Window & { [key: string]: any } {
    return _window();
  }
}
